import React from 'react';
import { Outlet } from 'react-router-dom';
import Box from '@mui/material/Box';
import { Button, Input, Table, message, Space, Form, InputNumber, Popconfirm, Typography } from 'antd';
import { useTheme } from '@mui/material/styles';
import LeftSidebar from '../adminPages/LeftSidebar';
import ProductUploadDrawer from '../components/drawers/ProductUploadDrawer';
import ProductEditDrawer from '../components/drawers/ProductEditDrawer';
import { useAdminControl } from '../store/Store';


const AdminAppLayout = () => {
  const theme = useTheme();

  const { activeDrawer, closeDrawer } = useAdminControl();
  const [messageApi, contextHolder] = message.useMessage();


  const showMessage = (type, content) => {
    messageApi.open({
      type: type,
      content: content,
    });
  };

  return (
    <Box sx={{ height: '100dvh', width: '100%', display: 'flex', flexDirection: 'column', bgcolor: '#f9fafb' }}>
      {contextHolder}

      <Box sx={{
        height: '72px', width: '100%', position: 'fixed', top: 0, left: 0, zIndex: 1000, display: 'flex', alignItems: 'center', bgcolor: '#fff',
        boxShadow: '0 1px 5px rgba(0,0,0,0.05)', justifyContent: 'center'
      }}>
        Hello world

      </Box>

      <Box sx={{ display: 'flex', flex: 1, width: '100%', overflow: 'hidden', mt: '72px' }}>

        <LeftSidebar />

        <Box sx={{
          flex: 1, height: 'calc(100vh - 48px)', overflowY: 'auto', bgcolor: '#f9fafb', ml: '110px', width: 'calc(100% - 110px)',
          height: 'calc(100dvh - 72px)'
        }}>

          <Box sx={{ maxWidth: '1280px', margin: '0 auto', width: '100%', px: { xs: 2, sm: 3, md: 4 } }}>
            <Outlet />
          </Box>

        </Box>
      </Box>



      <ProductUploadDrawer open={activeDrawer === 'productUpload'} onClose={closeDrawer} showMessage={showMessage} />
      <ProductEditDrawer open={activeDrawer === 'productEdit'} onClose={closeDrawer} showMessage={showMessage}/>


    </Box>
  );
};

export default AdminAppLayout;